import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Domain, Workspace } from "../../path";
import usePost from "../../Hooks/usePost";
import { useDispatch } from "react-redux";
import { Set_Loader } from "../../Redux/Action/LoaderAction";
import { toast } from "react-toastify";

const Analysis = () => {
  const { id, type } = useParams();
  const Dispatch = useDispatch();
  const Navigate = useNavigate();
  const [AnalysisData, setAnalysisData] = useState(null);
  const Analysis_Post = usePost(`${Workspace[Domain].API_Path}/child_analysis`);
  const InviteParent_Post = usePost(
    `${Workspace[Domain].API_Path}/invite_parents`
  );
  const BackHandler = () => {
    Navigate(`/`);
  };
  const InviteParent = () => {
    if (type == "class") {
      InviteParent_Post.Postcall({
        class_id: atob(id),
      });
    } else {
      InviteParent_Post.Postcall({
        school_id: atob(id),
      });
    }
  };

  useEffect(() => {
    if (type == "other") {
      Analysis_Post.Postcall({
        school_id: atob(id),
      });
    } else {
      Analysis_Post.Postcall({
        class_id: atob(id),
      });
    }
  }, []);

  useEffect(() => {
    if (Analysis_Post.Post != null) {
      switch (Analysis_Post.Post.status) {
        case 200:
          Dispatch(Set_Loader(false));
          setAnalysisData(() => Analysis_Post.Post.body);
          break;

        default:
          break;
      }
    }
  }, [Analysis_Post.Post]);

  useEffect(() => {
    if (InviteParent_Post.Post != null) {
      switch (InviteParent_Post.Post.status) {
        case 200:
          Dispatch(Set_Loader(false));
          toast.success("Invite sent successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [InviteParent_Post.Post]);

  return (
    <div className="h-full p-3">
      <button
        onClick={BackHandler}
        className="text-3xl mx-3 text-[black] flex items-center"
      >
        {" "}
        <i class="fa-solid fa-arrow-left-long"></i>
        <span className="text-[18px] ml-2 min-[700px]:hidden">Back</span>
      </button>
      <h3 className="my-3">
        <b className="text-md text-[black]">School name :</b>
        <span className="ml-2">
          {AnalysisData?.school_name[0]?.school_name || "-"}
        </span>
      </h3>

      <div className="border-2 p-5 bg-[white] w-[95%] mx-auto rounded min-[700px]:w-[50%]">
        <h3 className="font-semibold">
          Thank you for completing the evaluation for your class. Based on your
          evaluation it is advised that the following children be referred to
          further evaluation by their parents.
        </h3>
        <ol className="list-decimal px-5 my-4">
          {AnalysisData?.child_list?.map((item, index) => {
            return (
              <li className="my-2 font-medium" key={index}>
                {item?.child_name}
              </li>
            );
          })}
        </ol>
        <div
          className={`${
            AnalysisData?.child_list?.length == 0 ? "hidden" : ""
          } my-5 flex items-center flex-col`}
        >
          <a
            href={AnalysisData?.report_url}
            className="w-[60%] py-2 px-7 rounded-md bg-[#f79221] border-2  border-[#f79221] border-solid text-sm mx-3 text-[white] font-semibold max-[740px]:w-[98%] my-3"
          >
            Download the report for your class
          </a>
          <button
            onClick={InviteParent}
            className="underline text-[#f79221] font-semibold text-sm mx-3 max-[740px]:w-11/12 max-[740px]:my-2"
          >
            Invite parents
          </button>
        </div>
      </div>
    </div>
  );
};

export default Analysis;
